import {combineReducers} from 'redux';
import steps from './steps.reducer';
import loading from './loading.reducer';
import register from './register.reducer';
import navigation from './navigation.reducer';
import message from './message.reducer';
import brand from './brand.reducer';
import lead from './lead.reducer';

const registerReducers = combineReducers({
    steps,
    loading,
    register,
    navigation,
    message,
    brand,
    lead
});

export default registerReducers;